import { Link } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

///
import { getTokens } from "../../../redux/featuer/user/userSlice";
import { validateForm } from "../../../helper/helper";
import { Input } from "../../form/input";
import ChangeLanguage from "../../changeLanguage";
import pe2 from '../../p2e/index'
import toast from "react-hot-toast";




function LoginComponent() {


  const dispatch = useDispatch();
  const [show, setShow] = useState(true)
  const [switchPage, setSwitchPage] = useState(1);

  ////login 
  const [password, setPassword] = useState('')
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('');
  const [phoneSms, setPhoneSms] = useState('')
  const [showCode, setShowCode] = useState(false)

  ///password
  const [isShown] = useState(false);
  var { t } = useTranslation()








  useEffect(() => {
    document.title = t("login_to_account");
  }, [t])




  const submitForm = async (e) => {
    e.preventDefault();

    if (!validateForm(e)) return;

    var body = {
      phone: phone,
      username: phone,
      password: password
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER}/api/user/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const result = await res.json();
      if (result.status === "success") {
        dispatch(getTokens(result.data.token));
        window.location.href = "/auth";
      } else {
        setShow(true);
        toast.error(result.msg);
      }
    } catch (error) {
      console.log(error);
    }
  };




  const submitFormSmsCode = async (e) => {
    e.preventDefault();

    if (code.length < 3) {
      toast.error(t("verification_code_is_incorrect"));
      return;
    }




    var body1 = {
      phone: phoneSms,
      code: code
    };


    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER}/api/user/login/sms/code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body1),
      });

      const result = await res.json();
      if (result.status === "success") {
        toast.error(t("code_successfully_verified"));
        dispatch(getTokens(result.data.token));
        window.location.href = "/auth";
      } else {
        setShow(true);
        toast.error(result.msg);
      }
    } catch (error) {
      console.log(error);
    }
  };










  const receiveSMS = async (phone) => {
    try {

      let checkMobile = pe2(phoneSms).match(/^0?9[0-9]{9}$/)
      if (checkMobile) {

        const res = await fetch(`${process.env.REACT_APP_SERVER}/api/user/login/sms`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ phone: phone }),
        });
        if (res.status === 200) {
          setSwitchPage(2);
          setShowCode(true);
        }
      } else {
        return toast.error("شماره را درست وارد کنید")
      }
    } catch (error) {
      console.log(error);
      // handle error message for the user
    }
  };






  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen px-3">
        <div className="flex flex-col p-8 space-y-4 text-gray-600 bg-white border rounded-xl md:w-[500px]">
          <div className="flex flex-col items-center justify-center gap-3">
            <img src={process.env.REACT_APP_ADDRESS + "/logo.png"} className="!min-h-0 w-[70px] h-[70px]" alt="logo" />
            <p className="text-lg font-bold text-black">
              {t("login_to_account")}
            </p>
          </div>
          <div className="flex flex-col items-center justify-center gap-3">
            <div className="mb-4 border-b border-gray-200 dark:border-gray-700 ">
              <ul
                className="flex w-full -mb-px flex-w "
                id="myTab"
                data-tabs-toggle="#myTabContent"
                role="tablist"
              >
                <li className="" role="presentation">
                  <button
                    className={`inline-block p-4 ${switchPage === 1 && " border-blue-600"} text-xs text-blue-600 border-b-2  rounded-t-lg hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 dark:border-blue-500`}
                    id="profile-tab"
                    data-tabs-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="true"
                    onClick={() => setSwitchPage(1)}
                  >
                    {t("login_via_password")}
                  </button>
                </li>

                <li className="" role="presentation">
                  <button
                    className={`inline-block p-4 text-xs text-gray-500 border-b-2 border-transparent border-gray-100 rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 dark:border-transparent${switchPage === 2 && " !border-blue-600"}  dark:text-gray-400 dark:border-gray-700`}
                    id="dashboard-tab"
                    data-tabs-target="#dashboard"
                    type="button"
                    role="tab"
                    aria-controls="dashboard"
                    aria-selected="false"
                    onClick={() => setSwitchPage(2)}

                  >
                    {t("log_via_sms")}

                  </button>
                </li>
              </ul>
            </div>
          </div>


          {/* ////login [password] */}
          {switchPage === 1 && (
            <div id="myTabContent">
              {/* first */}
              <div
                className="space-y-6"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <form onSubmit={submitForm}>
                  <div className="relative mt-2 ">
                    <Input
                      placeholder={t("form_nameValidation")}
                      type="text"
                      id={"phone"}
                      name={"phone"}
                      autoComplete={"off"}
                      requiredir={true}
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                    />
                  </div>

                  <div className="relative mt-5 ">
                    <Input
                      id={"passwords"}
                      name={"passwords"}
                      autoComplete={"off"}
                      requiredir={true}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      type={isShown ? "text" : "password"}
                      placeholder={t("passwordValidation")}

                    />
                  </div>

                  {show === true ? (
                    <div className="flex items-start justify-center">
                      <button
                        className="h-10 mt-4 text-white bg-blue-500 rounded-lg w-52 "
                      >
                        {t("log_in")}
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-start justify-center">
                      <button
                        className="h-10 mt-4 text-white bg-blue-500 rounded-lg w-52 "
                        disabled={true}
                      >
                        {t("log_in")}
                      </button>
                    </div>
                  )
                  }
                </form>
              </div>
              {/* first */}
              {/* second */}
              <div
                className="hidden space-y-6"
                id="dashboard"
                role="tabpanel"
                aria-labelledby="dashboard-tab"
              >
                <div className="relative">
                  <input
                    type="text"
                    id="phones"
                    className="  block px-2.5 pb-2.5 pt-2 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                  />
                  <label
                    htmlFor="phones"
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900  peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
                  >
                    {t("phone")}
                  </label>
                </div>

                <div className="relative">
                  <input
                    id="pass"
                    type="text"
                    className="block px-2.5 pb-2.5 pt-2 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                  />
                  <label
                    htmlFor="pass"
                    className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900  peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
                  >
                    {t("send_code")}
                  </label>
                </div>
              </div>
              {/* second */}


            </div>

          )}


          {/* ////// login sms */}
          {switchPage === 2 && (
            <>
              {!showCode ? (
                <div className="space-y-6">

                  <div className="relative mt-5 ">
                    <Input
                      id={"phone-sms"}
                      name={"phone-sms"}
                      autoComplete={"off"}
                      value={phoneSms}
                      requiredir={true}
                      onChange={(e) => {
                        setPhoneSms(e.target.value);
                      }}
                      placeholder={t("enterNumber")}

                    />
                  </div>
                  <div className="relative mt-5 ">
                    <button
                      className="w-full h-10 text-white bg-blue-500 rounded-lg "
                      type="submit"
                      onClick={() => receiveSMS(phoneSms)}
                    >
                      {t("receive")}
                    </button>
                  </div>

                </div>
              ) :
                <>
                  <div className="space-y-6">

                    <div className="flex flex-col items-center justify-center gap-3">
                      <span>{t("code_for_the_number")} {phoneSms} {t("sent")}</span>
                      <span className="text-green-300 cursor-pointer" onClick={() => setShowCode(false)}>تغییر شماره</span>

                    </div>
                    <div className="relative">
                      <input
                        onChange={(e) => setCode(e.target.value)}
                        requiredir={true}
                        type="text"
                        id="code"
                        className="  block  px-2.5 pb-2.5 pt-2 border w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder="  "
                      />
                      <label
                        htmlFor="code"
                        className="absolute pr-3 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white   peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
                      >
                        {t("enter_code")}
                      </label>

                    </div>
                    <div className="relative mt-5 ">
                      <button
                        className="w-full h-10 text-white bg-blue-500 rounded-lg "
                        type="submit"
                        onClick={(e) => submitFormSmsCode(e)}
                      >
                        {t("sendCodeSms")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </>
          )}

          <Link to="/register">
            <div className="flex justify-center w-full gap-1 mt-3 text-sm">
              <div>
                <p className="text-red-600"  > {t("not_registered")}  </p>
              </div>
              <div>
                <p className="text-blue-600"  > {t("register")} </p>
              </div>
            </div>
          </Link>

        </div>
        {/* <ChangeLanguage language={"login_to_account"} /> */}

        {/* <div className="flex flex-col items-center p-4">
          <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=316885&Code=qvM9iKLkmLPVqqU4xaIJ">
            <img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=316885&Code=qvM9iKLkmLPVqqU4xaIJ" alt="test" className="!min-h-[100px] !h-[100px] cursor-pointer" id="qvM9iKLkmLPVqqU4xaIJ" />
          </a>
        </div> */}


      </div >

    </>
  );
}

export default LoginComponent;
